import type { Locale } from "./i18n.ts";

/**
 * Guide screenshots live at `/guide/<name>.png` (English, the default set) and
 * `/guide/es/<name>.png` (Spanish). Sections and the landing page reference
 * the English path; this returns the one to show for the viewer's locale.
 * A missing Spanish capture falls back to the English one at render time.
 */
export function guideImage(path: string, locale: Locale): string {
  if (locale !== "es" || !path.startsWith("/guide/") || path.startsWith("/guide/es/")) {
    return path;
  }
  return `/guide/es/${path.slice("/guide/".length)}`;
}
